import React from "react";
import { Box } from "@material-ui/core";
import PropTypes from 'prop-types';
import MyLeadContactDetailsStep from "./MyLeadContactDetailsStep/MyLeadContactDetailsStep";
import MyLeadUnitDetailsStep from "./MyLeadUnitDetailsStep/MyLeadUnitDetailsStep";
import MyLeadLeadDetailsStep from "./MyLeadLeadDetailsStep/MyLeadLeadDetailsStep";

const AddNewMyLeadSteps = ({
  state,
  selected,
  formType,
  activeStep,
  isQuickAdd,
  isSubmitted,
  onStateChangeHandler,
  onSelectedChangeHandler,
  setSelected,
  setState,
  translate,
  errors,
  setErrors
}) => {

  return (
    <Box>
      {activeStep === 0 && (
        <MyLeadContactDetailsStep
          state={state}
          selected={selected}
          isQuickAdd={isQuickAdd}
          isSubmitted={isSubmitted}
          onStateChangeHandler={onStateChangeHandler}
          onSelectedChangeHandler={onSelectedChangeHandler}
          translate={translate}
          errors={errors}
          setErrors={setErrors}
        />
      )}
      {activeStep === 1 && (
        <MyLeadUnitDetailsStep
          state={state}
          selected={selected}
          formType={formType}
          isSubmitted={isSubmitted}
          onStateChangeHandler={onStateChangeHandler}
          onSelectedChangeHandler={onSelectedChangeHandler}
          setSelected={setSelected}
          setState={setState}
          translate={translate}
        />
      )}
      {activeStep === 2 && (
        <MyLeadLeadDetailsStep
          state={state}
          selected={selected}
          isSubmitted={isSubmitted}
          onStateChangeHandler={onStateChangeHandler}
          onSelectedChangeHandler={onSelectedChangeHandler}
          translate={translate}
        />
      )}
    </Box>
  );
};

export default AddNewMyLeadSteps;

AddNewMyLeadSteps.propTypes = {
  formType: PropTypes.number.isRequired,
  isQuickAdd: PropTypes.bool.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  activeStep: PropTypes.number.isRequired,
  state: PropTypes.instanceOf(Object).isRequired,
  schema: PropTypes.instanceOf(Object).isRequired,
  onStateChangeHandler: PropTypes.func.isRequired,
  selected: PropTypes.instanceOf(Object).isRequired,
  onSelectedChangeHandler: PropTypes.func.isRequired,
};
